// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { Menu } from './types';

export interface ActionGetClientAPI extends Action {
}

export const getMenuAPI = (): ActionGetClientAPI => ({
    type: ACTIONS.GET_MENU_API_REQUEST,
});

export interface ActionGetMenuApiSuccess extends Action {
    menuItems: Menu[]
}

export const getMenuAPISuccess = (menuItems: Menu[]): ActionGetMenuApiSuccess => ({
    type: ACTIONS.GET_MENU_API_SUCCESS,
    menuItems
});

export const getMenuAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_MENU_API_ERROR,
    error
});